import { createContext, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { FCWithChildren } from 'common/types';

const value = uuidv4();

const FakeTemporaryVirtualPaymentCardIdContext = createContext(value);
const FakeTemporaryVirtualPaymentCardIdContextProvider: FCWithChildren = ({
  children,
}) => {
  return (
    <FakeTemporaryVirtualPaymentCardIdContext.Provider value={value}>
      {children}
    </FakeTemporaryVirtualPaymentCardIdContext.Provider>
  );
};
const useFakeTemporaryVirtualPaymentCardIdContext = () => {
  return useContext(FakeTemporaryVirtualPaymentCardIdContext);
};

export {
  FakeTemporaryVirtualPaymentCardIdContextProvider,
  useFakeTemporaryVirtualPaymentCardIdContext,
};
